import { Injectable, WritableSignal, signal } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment as env } from '@env/environment';
import { Observable } from 'rxjs';
import { CsvService } from '@core/services';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    loading: WritableSignal<undefined|boolean> = signal(undefined);   
    loading$ = toObservable(this.loading);

    data: null | any[] = [];

    constructor(
        private http: HttpClient,
        private service: CsvService) {}

    get(id: string, dates: string[]) : Observable<HttpResponse<any[]>> {
        return this.http.get<any[]>(env.API_URL + '/reports/' + id, {
            params: { date: dates}, 
            observe: 'response'
        });
    }

    download(rpt_id: string) {

        this.loading.update((val) => true); 

        this.get(rpt_id, []).subscribe({
            
            next: (resp) => {
                this.data = resp.body;
                this.loading.update((val) => false); 
            },
            error: (err) => {
                this.loading.update((val) => false); 
                console.log(err);
            },
            complete: () => {
                this.service.export(this.data);
            }
        });

       
    }
}



                